import { Sort } from './types';

export function formatSort<T>(sortBy?: Array<Sort<T>>) {
  return sortBy?.map(x => `${String(x.field)}:${x.direction}`);
}
